import React, { useState } from 'react'
import RandomTeamsRoundFirebase from './RandomTeamsRoundFirebase'
import DrawModal from '../Templates/DrawModal';

function TeamsDraw({registeredPlayers, id, roundId, requestCount, setRequestCount, round, setActiveItem}) {

    const [modal, setModal] = useState(false);

    function draw() {
        setModal(true)
        setActiveItem("2");
        setTimeout(() => {

            setActiveItem("3")
            window.scrollTo(0, 0)

        }, 500)
        setModal(false)
    }


    return (
        <React.Fragment>
            <div className="row">
                <div className="col-12 my-4">
                    <p>Antall lag: {round.num_teams}</p>
                    <p>Antall spillere per lag: {round.players_per_team}</p>
                    <div className="text-center">
                        <button className="btn btn-warning" onClick={draw}>Trekk nye lag</button>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <h4>Trekning 1</h4>
                    <RandomTeamsRoundFirebase 
                        id={id} 
                        roundId={roundId} 
                        players={registeredPlayers} 
                        draw="1" 
                        requestCount={requestCount} 
                        setRequestCount={setRequestCount} 
                        round={round}
                    />
                </div>
                <div className="col-md-6 col-lg-4">
                    <h4>Trekning 2</h4>
                    <RandomTeamsRoundFirebase 
                        id={id} 
                        roundId={roundId} 
                        players={registeredPlayers} 
                        draw="2" 
                        requestCount={requestCount} 
                        setRequestCount={setRequestCount} 
                        round={round}
                    />
                </div>
                <div className="col-md-6 col-lg-4">
                    <h4>Trekning 3</h4>
                    <RandomTeamsRoundFirebase 
                        id={id} 
                        roundId={roundId} 
                        players={registeredPlayers} 
                        draw="3" 
                        requestCount={requestCount} 
                        setRequestCount={setRequestCount} 
                        round={round}
                    />
                </div>
            </div>
            <DrawModal modal={modal} setModal={setModal} />
        </React.Fragment>
    )

}
export default TeamsDraw